import { PublicClientApplication } from '@azure/msal-browser';

let instance;

export async function initialize(msoConfig) {
  if (instance) throw new Error('msal client already initialized');

  if (msoConfig == null || !msoConfig.useClientSideAuth) return;
  const { clientId, tenantId } = msoConfig;

  const verbose = false;

  const config = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId ?? 'organizations'}`,
      redirectUri: window.location.hostname.endsWith('.localhost')
        ? `http://localhost:8080/?server-port=3000&domain-name=${window.location.hostname.replace('.localhost', '')}`
        : window.location.origin,
      OIDCOptions: {
        defaultScopes: ['openid', 'profile', 'email']
      },
      navigateToLoginRequestUrl: false
    },
    system: {
      iframeHashTimeout: 30000 /* 3 x default value, same value as redirectNavigationTimeout */,
      loggerOptions: verbose
        ? {
            loggerCallback: (level, message) => console.log('MSAL', message),
            logLevel: 4,
            piiLoggingEnabled: false
          }
        : undefined
    }
  };

  const msalClient = new PublicClientApplication(config);
  await msalClient.initialize();

  instance = msalClient;
}

export function getInstance() {
  return instance;
}
